import { lang } from '@umu/ukit-lang';
/**
 * @desc 注册引导 tip
 * @author Kody
 * @dete 2019-11-19
 */
import React from 'react';
import { components } from 'common';
const { PreImg } = components;
import { IUserInfo, IContextInfo } from '@umu/umu-types';
import { getData } from '@umu/umu-util';
import { gotoRegist } from '../../@utils/umuUtil';

import iconLogo from '../../images/defaultAvatar.png';
import './registGuideTip.scss';

interface IProps {
    userInfo: IUserInfo;
    contextInfo: IContextInfo;
    creatorInfo: IUserInfo;
}

export const RegistGuideTip = (props: IProps) => {
    const { creatorInfo, userInfo, contextInfo } = props;
    const isEnterprise =
        !!getData(userInfo, 'enterprise_info', 'enterprise_id') ||
        !!getData(contextInfo, 'enterprise_info', 'enterprise_id') ||
        !!getData(creatorInfo, 'enterprise_info', 'enterprise_id');

    if (isEnterprise || userInfo.umu_id) {
        return null;
    }
    return (
        <div className="regist-guide-tip">
            <div className="desc">
                <PreImg>
                    <img src={iconLogo} />
                </PreImg>
                {lang('用UMU设计有效果的学习过程')}
            </div>
            <button className="btn-regist" onClick={gotoRegist}>
                {lang('去注册')}
            </button>
        </div>
    );
};
